module.exports = __webpack_public_path__ + "img/good.1a16deb.png";